import { render, staticRenderFns } from "./ac-icon.vue?vue&type=template&id=2dd92671&scoped=true&"
import script from "./ac-icon.vue?vue&type=script&lang=js&"
export * from "./ac-icon.vue?vue&type=script&lang=js&"
import style0 from "./ac-icon.vue?vue&type=style&index=0&id=2dd92671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd92671",
  null
  
)

export default component.exports